import styled from "styled-components";

export const NegativeFeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--allie-spacing-md);
  padding: var(--allie-spacing-xl);
  border-radius: var(--allie-radius-md);
  border: 1px solid var(--allie-color-neutral-20);
  width: 100%;
  box-sizing: border-box;
`;

export const NegativeOption = styled.div<{ selected?: boolean }>`
  display: flex;
  padding: var(--allie-spacing-md) var(--allie-spacing-lg);
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  border-radius: var(--allie-radius-3xl);
  border: 1px solid var(--allie-color-neutral-30);
  background-color: ${({ selected }) =>
    selected ? 'var(--allie-color-primary-50)' : 'var(--allie-color-neutral-5)'};
  width: fit-content;
`;

export const NegativeTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  row-gap: var(--allie-spacing-xs);

  ion-icon {
    font-size: 24px;
    cursor: pointer;
  }
`;